var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplunk = function SvgSplunk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 110"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#splunk_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#splunk_svg__b)",
    d: "M90.6 109.1h-72C8.3 109.1 0 100.8 0 90.6v-72C0 8.3 8.3 0 18.5 0h72C100.7 0 109 8.3 109 18.5v72c.1 10.3-8.2 18.6-18.4 18.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M73 54.9c0 .1.1.2.1.3-.5.3-1.1.5-1.7.7-12.7 5.5-25.3 11-38 16.4-.5.3-.8.5-.8 1.1.1 2.6.1 5.2 0 7.9-.1.8.3.8.9.5 15.3-6.6 30.6-13.1 45.9-19.7.7-.3.8-.6.8-1.3q-.15-5.85 0-11.7c0-.7-.2-1-.8-1.2l-8.4-3c-12.4-4.4-24.8-8.8-37.2-13.3-1.1-.4-1.2-.4-1.2.8 0 2.6.1 5.3-.1 7.9-.1.8.3 1.2 1 1.4l30.6 10.2c3.1 1.1 6 2 8.9 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M73 54.9c-2.9-1-5.8-2-8.7-2.9-10.3-3.4-20.5-6.8-30.7-10.2-.8-.3-1-.6-1-1.4.1-2.6.1-5.3.1-8 0-1.2 0-1.2 1.2-.8C46.3 36 58.7 40.4 71 44.9l8.4 3c.7.2.9.6.8 1.2q-.15 5.85 0 11.7c0 .7-.2 1-.8 1.3-15.4 6.6-30.6 13.3-46 19.8-.6.3-.9.3-.9-.5.1-2.6.1-5.2 0-7.9 0-.6.2-.9.8-1.1 12.7-5.5 25.3-11 38-16.4.5-.3 1.1-.5 1.7-.7z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "splunk_svg__b",
    x1: 117.961,
    x2: -4.396,
    y1: 111.505,
    y2: 1.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78B43A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#A2CE6A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "splunk_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h109.1v109.1H0z"
  })))));
};
export default SvgSplunk;